
    import './styles.scoped.css';
    export default {
  "custom-range": "awsui_custom-range_16zmw_k2gxg_145",
  "custom-range--no-padding": "awsui_custom-range--no-padding_16zmw_k2gxg_151",
  "custom-range-form-controls": "awsui_custom-range-form-controls_16zmw_k2gxg_155",
  "custom-range-duration": "awsui_custom-range-duration_16zmw_k2gxg_159",
  "custom-range-unit": "awsui_custom-range-unit_16zmw_k2gxg_160",
  "vertical": "awsui_vertical_16zmw_k2gxg_166",
  "custom-range-duration-input": "awsui_custom-range-duration-input_16zmw_k2gxg_177",
  "custom-range-unit-select": "awsui_custom-range-unit-select_16zmw_k2gxg_178",
  "relative-range-radio-group": "awsui_relative-range-radio-group_16zmw_k2gxg_182"
};
  